import type { TOC } from '@ember/component/template-only';
import { PrismButton } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

interface SettingsUsersTablesCellsCellActionsSignature {
  Args: {
    cellData: string;
    row: {
      isDisabled?: boolean;
      onDelete?: () => void;
    };
  };
}

const CellActions = <template>
  <PrismButton
    @buttonType="secondary"
    @icon="bin"
    @isDisabled={{@row.isDisabled}}
    @onClick={{@row.onDelete}}
    @size="small"
    aria-label={{t "settings.users.action.delete"}}
    data-test-id="cell-actions-delete-button"
  />
</template> satisfies TOC<SettingsUsersTablesCellsCellActionsSignature>;

export default CellActions;
